import type { Resource } from '../../';
export const product_recommendations_title: Resource = {"default":"You May Also Like"};
